<template>
  <div class="table-responsive">
    <table class="table transfer-details-table">
      <tbody>
        <tr>
          <td :class="smallTextClass">{{ labels.timestamp }}</td>
          <td class="prop-value" :class="smallTextClass">{{ dateResolver(transfer?.ts) }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.type }}</td>
          <td class="prop-value" :class="smallTextClass">{{ transferTypeResolver(transfer?.tt) }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.code }}</td>
          <td class="prop-value" :class="smallTextClass">{{ transfer?.sc }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.name }}</td>
          <td v-if="isBulgarian" class="prop-value" :class="smallTextClass">{{ transfer?.nBG ? transfer?.nBG : transfer?.nEN }}</td>
          <td v-if="isEnglish" class="prop-value" :class="smallTextClass">{{ transfer?.nEN }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.exchange }}</td>
          <td class="prop-value" :class="smallTextClass">{{ transfer?.xc }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.segment }}</td>
          <td class="prop-value" :class="smallTextClass">{{ transfer?.sgm }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.type }}</td>
          <td class="prop-value" :class="smallTextClass">{{ stockTypeResolver(transfer?.stid) }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ quantityLabel }}</td>
          <td class="prop-value" :class="smallTextClass">{{ parseNumber(transfer?.qty, 0) }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.price }}</td>
          <td v-if="transfer?.stid === 2" class="prop-value" :class="smallTextClass">{{ formatTransferValue(transfer?.sp, "%").replace(" ", "&nbsp;") }}</td>
          <td v-else class="prop-value" :class="smallTextClass">{{ formatTransferValue(transfer?.sp, transfer?.cc, 4).replace(" ", "&nbsp;") }}</td>
        </tr>
        <tr>
          <td :class="smallTextClass">{{ labels.totalAmount }}</td>
          <td class="prop-value" :class="smallTextClass">{{ formatTransferValue(transfer?.pt, transfer?.cc, 2).replace(" ", "&nbsp;") }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    transfer: { type: Object, default: null },
    windowWidth: { type: Number, required: true },
    userLanguage: { type: String, required: true },
    labels: { type: Object, required: true },
    dateResolver: { type: Function, required: true },
    transferTypeResolver: { type: Function, required: true },
    stockTypeResolver: { type: Function, required: true },
    formatPrice: { type: Function, required: true },
    parseNumber: { type: Function, required: true }
  },
  methods: {
    formatTransferValue(value, currency, autoDigits = null) {
      const numericValue = "number" === typeof value
        ? value
        : "string" === typeof value && "" !== value.trim()
          ? Number(value)
          : NaN;
      if (!Number.isFinite(numericValue) || 0 === numericValue) {
        return "n/a";
      }

      return this.formatPrice(value, currency, autoDigits);
    }
  },
  computed: {
    smallTextClass() {
      return { "xsmall-font-size": 1200 > this.windowWidth };
    },
    isBulgarian() {
      return 0 === "BG".localeCompare(this.userLanguage);
    },
    isEnglish() {
      return 0 === "EN".localeCompare(this.userLanguage);
    },
    quantityLabel() {
      return this.transfer?.stid === 2 ? this.labels.faceValue : this.labels.quantity;
    }
  }
};
</script>

<style scoped>
.prop-value {
  text-align: right;
  font-weight: bold;
}

.transfer-details-table td {
  font-size: 1rem;
  line-height: 1.35;
  padding: 0.6rem 0.5rem;
}

.xsmall-font-size {
  font-size: 1rem;
}
</style>
